/** Касание — то, что произошло с клиентом: звонок, встреча, письмо, сообщение. */
export const TOUCH_KINDS = ['call', 'meeting', 'email', 'message'] as const;
export type TouchKind = (typeof TOUCH_KINDS)[number];

/** Мы написали или позвонили — или нам. */
export const TOUCH_DIRECTIONS = ['outgoing', 'incoming'] as const;
export type TouchDirection = (typeof TOUCH_DIRECTIONS)[number];

/** Объект журнала и живых обновлений: касание. */
export const TOUCH_ENTITY = 'touch';

export const TOUCH_SUMMARY_MAX = 5_000;

/** Часы на компьютерах расходятся: касание «на минуту вперёд» не ошибка. */
export const TOUCH_FUTURE_TOLERANCE_MS = 5 * 60_000;

export type TouchIssue =
  'kind_invalid' | 'direction_invalid' | 'summary_required' | 'summary_too_long' | 'at_future';

export const isTouchKind = (value: string): value is TouchKind =>
  (TOUCH_KINDS as readonly string[]).includes(value);

export const isTouchDirection = (value: string): value is TouchDirection =>
  (TOUCH_DIRECTIONS as readonly string[]).includes(value);

/** Сводка: «кто, кому, о чём договорились»; пробелы по краям убираются. */
export const normalizeSummary = (value: string | null | undefined): string => (value ?? '').trim();

export interface TouchInput {
  readonly kind: string;
  readonly direction: string;
  readonly at: Date;
  readonly summary: string | null | undefined;
}

/**
 * Что не так с записываемым касанием. Сводка обязательна: без неё журнал бесполезен (у касания из
 * выполненного шага она может быть пустой — факт звонка важнее, чем слова).
 */
export function touchIssues(
  input: TouchInput,
  now: Date,
  options: { readonly summaryOptional?: boolean } = {},
): TouchIssue[] {
  const issues: TouchIssue[] = [];
  if (!isTouchKind(input.kind)) issues.push('kind_invalid');
  if (!isTouchDirection(input.direction)) issues.push('direction_invalid');
  const summary = normalizeSummary(input.summary);
  if (summary === '' && options.summaryOptional !== true) issues.push('summary_required');
  else if (summary.length > TOUCH_SUMMARY_MAX) issues.push('summary_too_long');
  if (input.at.getTime() > now.getTime() + TOUCH_FUTURE_TOLERANCE_MS) issues.push('at_future');
  return issues;
}

/** Править касание может автор, удалить — автор или тот, кто управляет продажами. */
export const canEditTouch = (touch: { readonly authorId: string }, userId: string): boolean =>
  touch.authorId === userId;

export const canDeleteTouch = (
  touch: { readonly authorId: string },
  userId: string,
  manage: boolean,
): boolean => touch.authorId === userId || manage;
